
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getForms,
  editForm,
  addForm,
} from '@pingum/app-state-management/form/actions';
import { LinearProgress } from '@material-ui/core';

// import StatusList from './components/StatusList';
import FormSettingsHeader from './components/FormSettingsHeader';
import FormsList from './components/FormsList';
import AddEditFormModal from './components/AddEditFormModal';
import Page from '../../widgets/Page';
import DisplayMessage from '../../widgets/DisplayMessage';

export class FormSettingsComponent extends React.Component {
  constructor(props) {
    super(props);

    if (!props.formsLoaded) {
      props.getForms();
    }

    this.state = {
      addEditModalOpen: false,
      selectedEditForm: null,
    };

    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleCloseAddEditModal = this.handleCloseAddEditModal.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleArchiveClick = this.handleArchiveClick.bind(this);

    this.endOfList = { scrollIntoView: () => {} };
  }

  handleAddClick() {
    this.setState({
      addEditModalOpen: true,
      selectedEditForm: null,
    });
  }

  handleCloseAddEditModal() {
    this.setState({
      addEditModalOpen: false,
      selectedEditForm: null,
    });
  }

  handleEditClick(form) {
    this.setState({
      addEditModalOpen: true,
      selectedEditForm: form,
    });
  }

  handleArchiveClick(form) {
    this.props.editForm(form.id, { archived: !form.archived });
  }

  render() {
    const {
      forms,
      formsLoaded,
      isAddingForm,
      isFetchingForms,
      isEditingForm,
      includeArchived,
    } = this.props;
    const {
      addEditModalOpen,
      selectedEditForm,
    } = this.state;

    return (
      <Page
        title="Form Settings"
        disableToolbarPadding
      >
        <div>
          <FormSettingsHeader
            onAddForm={this.handleAddClick}
            isAddingForm={isAddingForm}
          />

          { isFetchingForms && <LinearProgress /> }

          <FormsList
            forms={forms}
            includeArchived={includeArchived}
            isLoading={isFetchingForms || isAddingForm || isEditingForm}
            onEditClick={this.handleEditClick}
            onArchiveClick={this.handleArchiveClick}
          />

          <AddEditFormModal
            form={selectedEditForm}
            open={addEditModalOpen}
            onClose={this.handleCloseAddEditModal}
          />

          {
            (formsLoaded
              && forms.length === 0)
              && (
                <DisplayMessage
                  title="No Forms"
                  icon="error_outline"
                />
              )
            }
        </div>
      </Page>
    );
  }
}

FormSettingsComponent.propTypes = {
  editForm: PropTypes.func.isRequired,
  getForms: PropTypes.func.isRequired,
  includeArchived: PropTypes.bool,
  forms: PropTypes.array,
  formsLoaded: PropTypes.bool,
  isAddingForm: PropTypes.bool,
  isFetchingForms: PropTypes.bool,
  isEditingForm: PropTypes.bool,
};

FormSettingsComponent.defaultProps = {
  forms: [],
  formsLoaded: false,
  includeArchived: false,
  isAddingForm: false,
  isFetchingForms: false,
  isEditingForm: false,
};

export const mapStateToProps = (state) => ({
  forms: state.form.forms,
  formsLoaded: state.form.formsLoaded,
  includeArchived: state.form.includeArchived,
  isAddingForm: state.form.isAddingForm,
  isFetchingForms: state.form.isFetchingForms,
  isEditingForm: state.form.isEditingForm,
});

export const mapDispatchToProps = (dispatch) => ({
  addForm: (request) => dispatch(addForm(request)),
  editForm: (id, request) => dispatch(editForm(id, request)),
  getForms: (includeArchived) => dispatch(getForms(includeArchived)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormSettingsComponent);
